import { render } from "./MapEditOptionsAppearance.vue?vue&type=template&id=edcb89e2&scoped=true&bindings={\"modelValue\":\"props\",\"mapData\":\"options\"}"
import script from "./MapEditOptionsAppearance.vue?vue&type=script&lang=js"
export * from "./MapEditOptionsAppearance.vue?vue&type=script&lang=js"

import "./MapEditOptionsAppearance.vue?vue&type=style&index=0&id=edcb89e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-edcb89e2"

export default script